import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { motion } from 'framer-motion';
import Title from "../components/ui/Title";
import { OtherBio, OtherData } from '../data/CharacterData';
import '../styles/pages/character.scss'

const Character = () => {

    const [current, setCurrent] = useState(0)
    const [other, setOther] = useState(0)
    const [visible, setVisible] = useState(false)

    const changeCurrrent = (number) => {
        setCurrent(number)
    }


    return (
        <div className="page-container">
            <Title text="Main Characters"/>
            <section className="character-list">
            {
                Data.map((character, index)=>(
                    <motion.div className="card-wrapper"
                        initial={{
                            x: '-50%',
                            opacity: 0
                        }}
                        animate={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            delay: index*0.25,
                            ease: 'easeOut'
                        }}
                    >
                        <CharacterCard character={character} current={current === index} onClick={()=>{
                            changeCurrrent(index)
                        }}/>
                    </motion.div>
                ))
            }
            <div className="marker" id="character"></div>
            </section>
            <motion.article className="character-container"
                initial={{
                    opacity: 0
                }}
                animate={{
                    opacity: 1
                }}
                transition={{
                    delay: 1
                }}
            >
                <div className={Data[current].image==="tio" ? "foreground tio" : "foreground"}
                    style={{backgroundImage: `url(${process.env.PUBLIC_URL}/img/characters/attack/${Data[current].image}.webp)`}}
                >
                    <div className="right">
                        <motion.div className="text-wrapper">
                        {
                            ReactHtmlParser(Data[current].bio)
                        }
                        </motion.div>
                    </div>
                </div>
                <div className="background">

                    <h1 style={{backgroundColor: Data[current].color}}>
                        {
                            Data[current].name
                        }
                    </h1>
                </div>
            </motion.article>
            <h1 className="character-subtitle">
                Side Characters:
            </h1>
            <section className={`other-modal ${visible && "visible"}`}>
                <Other name={OtherData[other].name} image={OtherData[other].image} index={other} visible={visible}/>
                <div className="button-nav">
                    {other !== 0 && <button
                        onClick={()=>{
                            setOther(other-1)
                        }}
                    >Previous</button>}
                    {other !== OtherData.length-1 && <button
                        onClick={()=>{
                            setOther(other+1)
                        }}
                    >Next</button>}
                </div>
                <button onClick={()=>{setVisible(false)}}>Close</button>
            </section>
            <section className="other-character_list">
            {
                OtherData.map((other, index) => (
                    <OtherCharacterCard image={other.image} index={index} setOther={setOther} setVisible={setVisible} classes={other.classes}/>
                ))
            }
            </section>
        </div>
    )
}

const OtherCharacterCard = ({image, index, setOther, setVisible, classes}) => (
    <div className="other-card" onClick={
        ()=>{
            setOther(index)
            setVisible(true)
        }
    }>
        <img src={`./img/characters/bu/${image}.webp`} className={`${classes}`} alt="" />
    </div>
)


const CharacterCard = ({character, current, ...props}) => {
    return (
        <a href="#character">
            <div className={current ? "character-card current" : "character-card"}
                style={character.size === "short" ? {backgroundImage: `url(${process.env.PUBLIC_URL}/img/characters/${character.image}.webp)`, backgroundPosition: "50% 27%"} : {backgroundImage: `url(${process.env.PUBLIC_URL}/img/characters/${character.image}.webp)`}}
                {...props}
            >
                <h1
                    style={{backgroundColor: `${character.color}`}}
                >
                    {character.first}
                </h1>
            </div>
        </a>
    )
}

const Other = ({name, image, index, visible}) => (
    <div className="other-wrapper" style={{backgroundImage: `url(./img/characters/full/${image}.webp)`}}>
        <div className="other-left">
            <div className="other-pair">
                <img src={`./img/characters/bu/${image}.webp`} alt="" className="other-body" />
                <h1 className="other-name">
                    {name}
                </h1>
            </div>
            <div className="bio-wrapper">
                {
                    OtherBio[index]
                }
            </div>
        </div>
        <div className="other-right">
            
        </div>
    </div>
)

const Data = [
    {
        name: "Lloyd Bannings",
        first: "Lloyd",
        image: "lloyd",
        bio: "<p>A young detective from the Crossbell Police Department and returning protagonist of <em>Trails from Zero</em>.</p><p>After extenuating circumstances led to the temporary dissolution of the Special Support Section, he transferred to the First Investigative Division to receive formal training in counterintelligence and counterterrorism.</p>",
        color: "#00aded"
    },
    {
        name: "Elie MacDowell",
        first: "Elie",
        image: "elie",
        bio: "<p>The granddaughter of former Crossbell City Mayor Henry MacDowell and a founding member of the Special Support Section, alongside Lloyd.</p><p>After the temporary dissolution of the SSS, she took a leave of absence from the police department to assist her grandfather's new role as Speaker of the Crossbell Diet.</p>",
        color: "#ff739c"
    },
    {
        name: "KeA",
        first: "KeA",
        image: "kea",
        bio: "<p>A girl with amnesia rescued by the Special Support Section in <em>Trails from Zero</em>. Bright-eyed and innocent, she is beloved by all who meet her. Since being taken in by the SSS, she has begun attending Sunday School.</p>",
        size: "short",
        color: "#f7ab00"
    },
    {
        name: "Tio Plato",
        first: "Tio",
        image: "tio",
        bio: "<p>A calm and collected, if somewhat distant, girl who transferred to the Crossbell Police Department from the Epstein Foundation.</p><p>In addition to her enhanced sensory receptivity, she wields a special weapon developed by the foundation known as an orbal staff.</p><p>After the temporary dissolution of the SSS, she returned to the Epstein Foundation's headquarters in Leman to continue her work on the orbal network.</p>",
        size: "short",
        color: "#2c2c45"
    },
    {
        name: "Randy Orlando",
        first: "Randy",
        image: "randy",
        bio: "<p>A former enlistee from the Crossbell Guardian Force and the oldest founding member of the Special Support Section.</p><p>At present, he has returned to the CGF to assist Warrant Officer Mireille with rehabilitating the guardsmen who had been drugged during the Cult Incident.</p><p>Prior to arriving in Crossbell, Randy was a member of the Red Constellation, one of the most powerful jaeger corps in all of Zemuria.</p>",
        color: "#d91313"
    },
    {
        name: "Noel Seeker",
        first: "Noel",
        image: "noel",
        bio: "<p>A Sergeant Major of the Crossbell Guardian Force.</p><p>Her promising skillset led to her appointment at a young age, but for some reason, she has been temporarily assigned to the Special Support Section...</p>",
        color: "#1b381e"
    },
    {
        name: "Wazy Hemisphere",
        first: "Wazy",
        image: "wazy",
        bio: "<p>A mysterious boy of both masculine and feminine charms.</p><p>Once the leader of the Testaments, a delinquent group in Crossbell's Downtown District, he decides to switch things up and join the Special Support Section for motives unknown...</p>",
        color: "#8fc31f"
    }

]

export default Character;